import React from 'react'
import { BrowserContext } from './BrowserContext'
import { errorMiddleware } from '@/services/errorMiddleware'

interface Props {
  children: React.ReactNode
}

export const BrowserProvider: React.FC<Props> = ({ children }) => {
  const [isMobile, setIsMobile] = React.useState(false)
  const [isTablet, setIsTablet] = React.useState(false)
  const [isDesktop, setIsDesktop] = React.useState(false)
  const [windowWidth, setWindowWidth] = React.useState(0)
  const [windowHeight, setWindowHeight] = React.useState(0)
  const [scrollPosition, setScrollPosition] = React.useState(0)
  const [ip, setIp] = React.useState('')

  React.useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth)
      setWindowHeight(window.innerHeight)
      setIsMobile(window.innerWidth < 768)
      setIsTablet(window.innerWidth >= 768 && window.innerWidth < 1024)
      setIsDesktop(window.innerWidth >= 1024)
    }

    const handleScroll = () => {
      setScrollPosition(window.scrollY)
    }

    window.addEventListener('resize', handleResize)
    window.addEventListener('scroll', handleScroll)
    handleResize()
    handleScroll()

    return () => {
      window.removeEventListener('resize', handleResize)
      window.removeEventListener('scroll', handleScroll)
    }
  }, [])

  React.useEffect(() => {
    if (ip) {
      sessionStorage?.setItem('X-Client-IP', ip)
      return
    }

    fetch('https://api.ipify.org?format=json')
      .then((response) => response.json())
      .then((data) => data?.ip && setIp(data.ip))
      .catch((error) => errorMiddleware(error))
  }, [ip])

  const state = {
    isMobile,
    isTablet,
    isDesktop,
    windowWidth,
    windowHeight,
    scrollPosition,
  }

  return (
    <BrowserContext.Provider value={state}>{children}</BrowserContext.Provider>
  )
}
